import './searchMainResults.scss';
import ItemMainSearch from './itemMainSearch/ItemMainSearch';
import { IItemResultSearch } from 'types/interfaces';
import { CSSProperties } from 'react';

type SearchResultsProps = {
  results: Array<IItemResultSearch>;
  noNav?: boolean;
  typesAvoid?: Array<string>;
  style?: CSSProperties;
};

export default function SearchMainResults({
  results,
  noNav = false,
  typesAvoid,
  style,
}: SearchResultsProps) {
  return (
    <div className='searchResults' style={style}>
      {results?.length
        ? results
            .filter((result) => (!typesAvoid ? result : !typesAvoid.includes(result.type)))
            .map((item) => {
              return (
                <ItemMainSearch
                  title={item.name}
                  description={item.desc}
                  key={`'searchMainR_'${item.id}_${item.name}`}
                  code={item.code}
                  onClick={item.onClick}
                  onClickNav={item.onClickNav}
                  transportMode={item.transportMode}
                  type={item.type}
                  routeColor={item.routeColor}
                  routeTextColor={item.routeTextColor}
                  noNav={noNav}
                />
              );
            })
        : null}
    </div>
  );
}
